import Messages from "./messages.json"
import { type NestedDictionary, create as createI18nSore } from "./store"

export type { Messages, NestedDictionary }

export const t = createI18nSore(Messages)
